/**
 * @generated SignedSource<<6bffa4411017429251cce91466f25b2c>>
 * @relayHash f7bb335b70d26ad812bfb3643de03577
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID f7ffa147cd1d4533462f1fb2c3c994f63b873577cc20f9e4875b94343191953c

import type { ConcreteRequest } from 'relay-runtime';
export type useIsLoomEntryPointsEnabledQuery$variables = {
  cloudId: string;
  includeMeetingRecorderEligibility: boolean;
};
export type useIsLoomEntryPointsEnabledQuery$data = {
  readonly confluence_loomEntryPoints: {
    readonly isLoomEntryPointsEnabled: boolean;
  } | null;
  readonly loom_connectedCalendars?: ReadonlyArray<{
    readonly guid: string;
  } | null> | null;
  readonly loom_settings?: {
    readonly meetingNotesEligible: boolean | null;
    readonly meetingRecordingsAvailable: boolean | null;
  } | null;
};
export type useIsLoomEntryPointsEnabledQuery = {
  response: useIsLoomEntryPointsEnabledQuery$data;
  variables: useIsLoomEntryPointsEnabledQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "includeMeetingRecorderEligibility"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "siteId",
    "variableName": "cloudId"
  }
],
v2 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
      }
    ],
    "concreteType": "ConfluenceLoomEntryPoints",
    "kind": "LinkedField",
    "name": "confluence_loomEntryPoints",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "isLoomEntryPointsEnabled"
      }
    ]
  },
  {
    "condition": "includeMeetingRecorderEligibility",
    "kind": "Condition",
    "passingValue": true,
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "LoomSettings",
        "kind": "LinkedField",
        "name": "loom_settings",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "meetingRecordingsAvailable"
          },
          {
            "kind": "ScalarField",
            "name": "meetingNotesEligible"
          }
        ]
      },
      {
        "args": (v1/*: any*/),
        "concreteType": "LoomConnectedCalendar",
        "kind": "LinkedField",
        "name": "loom_connectedCalendars",
        "plural": true,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "guid"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useIsLoomEntryPointsEnabledQuery",
    "selections": (v2/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useIsLoomEntryPointsEnabledQuery",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "f7bb335b70d26ad812bfb3643de03577",
    "id": "f7ffa147cd1d4533462f1fb2c3c994f63b873577cc20f9e4875b94343191953c",
    "metadata": {},
    "name": "useIsLoomEntryPointsEnabledQuery",
    "operationKind": "query",
    "text": "query useIsLoomEntryPointsEnabledQuery($cloudId:ID!,$includeMeetingRecorderEligibility:Boolean!){confluence_loomEntryPoints(cloudId:$cloudId){isLoomEntryPointsEnabled},loom_settings(siteId:$cloudId)@include(if:$includeMeetingRecorderEligibility){meetingRecordingsAvailable,meetingNotesEligible}\n  loom_connectedCalendars(siteId:$cloudId)@include(if:$includeMeetingRecorderEligibility){guid}}"
  }
};
})();

(node as any).hash = "992c3639759f7aa3511f220e9547ecc6";

export default node;
